<template>
  <NavBar />

  <main id="top">
    <HeroSection />

    <section id="services" aria-label="Services">
      <ServiceSection />
    </section>

    <section id="work" aria-label="Before and after gallery">
      <GallerySection />
    </section>

    <section id="process" aria-label="How it works">
      <ProcessSection />
    </section>

    <section id="contact" aria-label="Contact">
      <ContactSection />
    </section>
  </main>

  <SiteFooter />
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import HeroSection from './components/HeroSection.vue'
import ServiceSection from './components/ServiceSection.vue'
import GallerySection from './components/GallerySection.vue'
import ProcessSection from './components/ProcessSection.vue'
import ContactSection from './components/ContactSection.vue'
import SiteFooter from './components/SiteFooter.vue'
</script>
